export enum EDisabledFeatures {
  TARGETS = 'targets',
  FOLDERS = 'folders',
  SIGNATURES = 'signatures',
  AUTOREPLY = 'autoreply',
  CONTACTS = 'contacts',
  FILTERS = 'filters'
}
